/* eslint-disable import/prefer-default-export */

import React from 'react';
import IconGo from '../../Icons/IconGo';
import IconMonedero from '../../Icons/IconMondero';
import IconUnfilledBag from '../../Icons/IconUnfilledBag';
import { PriceFormatter } from '../../utils/PriceFormatter';
import DeepLinkService from '../../services/DeepLinkService';
import routerLoader from '../../i18n/router';

export class AhorrosHelper {
  static initializeListeners = () => {
    const input = document.getElementsByClassName(
      'react-datepicker-ignore-onclickoutside',
    )[0] as HTMLElement;
    const calendar = AhorrosHelper.getCalendarElement();

    if (input) {
      input.addEventListener(
        'mouseup',
        () => {
          if (calendar) {
            calendar.classList.remove('hide');
          }
        },
        false,
      );
    }
  };

  static hideCalendar = () => {
    const calendar = AhorrosHelper.getCalendarElement();
    if (calendar) {
      calendar.classList.add('hide');
    }
  };

  private static getCalendarElement = () => {
    return document.getElementsByClassName(
      'react-datepicker-popper',
    )[0] as HTMLElement;
  };

  static ventajasSaldoWeb = (moneda, saldoPath: string, saldo: any, t: any) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={saldoPath}>
          <div className="bloque-ventaja bloque-ventaja__ahorro">
            <div className="icon icon-medium icon--white bloque-ventaja__link">
              <IconGo />
            </div>

            <p className="bloque-ventaja__titulo">{t('saldo.title')}</p>

            <div className="bloque-ventaja__content">
              <div className="bloque-ventaja__num">
                <p className="saldo">
                  {saldo}
                  <sup>{moneda === 'euro' ? t('euro') : t('cc')}</sup>
                </p>
                <p className="text">{t('ahorros.en-monedero')}</p>
              </div>

              <div className="icon icon--white icon-extrahuge">
                <IconMonedero />
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  static ventajasSaldoApp = (moneda, saldoPath: string, saldo: any, t: any) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={saldoPath}>
          <div className="bloque-ventaja bloque-ventaja__ahorro">
            <div className="icon icon-medium icon--white bloque-ventaja__link">
              <IconGo />
            </div>

            <p className="bloque-ventaja__titulo">{t('saldo.title')}</p>

            <div className="bloque-ventaja__content">
              <div className="bloque-ventaja__num">
                <p className="saldo">
                  {saldo}
                  <sup>{moneda === 'euro' ? t('euro') : t('cc')}</sup>
                </p>
                <p className="text">{t('ahorros.en-monedero')}</p>
              </div>

              <div className="icon icon--white icon-extrahuge">
                <IconMonedero />
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  static ventajasPuntosTravelWeb = (
    puntosPath: string,
    puntos: any,
    t: any,
  ) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={puntosPath}>
          <div className="bloque-ventaja bloque-ventaja__travel">
            <div className="icon icon-medium icon--white bloque-ventaja__link">
              <IconGo />
            </div>

            <p className="bloque-ventaja__titulo">
              {t('ahorros.puntos-travel')}
            </p>

            <div className="bloque-ventaja__content">
              <div className="bloque-ventaja__num">
                <p className="saldo">
                  {puntos} <span>{t('ahorros.puntos')}</span>
                </p>
              </div>

              <div className="img">
                <img
                  src="../assets/images/logo-travel.png"
                  alt="Logo travel club"
                  className="logo travel club"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  static ventajasPuntosTravelApp = (
    puntosPath: string,
    puntos: any,
    t: any,
  ) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={puntosPath}>
          <div className="bloque-ventaja bloque-ventaja__travel">
            <div className="icon icon-medium icon--white bloque-ventaja__link">
              <IconGo />
            </div>

            <p className="bloque-ventaja__titulo">
              {t('ahorros.puntos-travel')}
            </p>

            <div className="bloque-ventaja__content">
              <div className="bloque-ventaja__num">
                <p className="saldo">
                  {`${puntos} `}
                  <span>{t('ahorros.puntos')}</span>
                </p>
              </div>

              <div className="img">
                <img
                  src="../assets/images/logo-travel.png"
                  alt="Logo travel club"
                  className="logo travel club"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  static ventajasComprasWeb = (
    pathCompras: string,
    moneda: string | undefined,
    compras: any,
    mes: string,
    t: any,
  ) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={pathCompras}>
          <div className="bloque-ventaja bloque-ventaja__compras">
            <div className="icon icon-medium icon--white bloque-ventaja__link">
              <IconGo />
            </div>

            <p className="bloque-ventaja__titulo">{t('ahorros.compras')}</p>

            <div className="bloque-ventaja__content">
              <div className="bloque-ventaja__num">
                <p className="saldo">
                  {compras}
                  <sup>{moneda === 'euro' ? t('euro') : t('cc')}</sup>
                </p>
                <p className="text">
                  {t('ahorros.en')} {mes}
                </p>
              </div>

              <div className="icon icon--white icon-extrahuge">
                <IconUnfilledBag />
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  static ventajasComprasApp = (
    moneda: string | undefined,
    compras: any,
    mes: string,
    t: any,
  ) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <div className="bloque-ventaja bloque-ventaja__compras">
          {/* <div className="icon icon-medium icon--white bloque-ventaja__link"> */}
          {/*  <IconGo /> */}
          {/* </div> */}

          <p className="bloque-ventaja__titulo">{t('ahorros.compras')}</p>

          <div className="bloque-ventaja__content">
            <div className="bloque-ventaja__num">
              <p className="saldo">
                {compras}
                <sup>{moneda === 'euro' ? t('euro') : t('cc')}</sup>
              </p>
              <p className="text">
                {t('ahorros.en')} {mes}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  static ventajasAhorraMasWeb = (pathAhorros: string, t: any) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href={pathAhorros}>
          <div className="bloque-ventaja ">
            {/* <div className="icon icon-medium bloque-ventaja__link"> */}
            {/*  <IconGo /> */}
            {/* </div> */}

            <p className="bloque-ventaja__titulo">{t('ahorros.ahorramas')}</p>

            <div className="bloque-ventaja__content">
              <p>{t('ahorros.gasolina')} ...</p>
            </div>
          </div>
        </a>
      </div>
    );
  };

  static ventajasAhorraMasApp = (t: any) => {
    return (
      <div className="col-12 col-sm-6 col-lg-3">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <div className="bloque-ventaja ">
          <div className="icon icon-medium bloque-ventaja__link">
            <IconGo />
          </div>

          <p className="bloque-ventaja__titulo">{t('ahorros.ahorramas')}</p>

          <div className="bloque-ventaja__content">
            <p>{t('ahorros.gasolina')} ...</p>
          </div>
        </div>
      </div>
    );
  };

  private static priceFormatter = (cell: any) => {
    return PriceFormatter.formatStringAsPrice(cell as string, '');
  };

  static getRowName = (row: string) => {
    if (row === 'ahorroTarjetaEroski') {
      return 'tarjeta-credito';
    }
    if (row === 'ahorroPertenenciaPlan') {
      return 'pertenencia-plan';
    }
    if (row === 'ahorroOfertasSocio') {
      return 'oferta-socio';
    }
    if (row === 'ahorroComprasOnlineOtrasEmpresas') {
      return 'otras-empresas';
    }
    if (row === 'ahorroTarjetaOro') {
      return 'tarjeta-oro-club';
    }
    if (row === 'ahorroEmpresasBonificadas') {
      return 'ahorroEmpresasBonificadas';
    }
    if (row === 'ahorroOtros') {
      return 'otros-ahorros';
    }
    if (row === 'ahorroVales') {
      return 'vales-ahorro';
    }
    return '';
  };

  private static getWebViewFront = (
    vistaFront: string[],
    deepLinkApp: string[],
    idioma: string,
    isApp: boolean,
    isCaprabo: boolean,
  ) => {
    const arrayUrlYDeep: string[] = new Array<string>();
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < vistaFront.length; j++) {
      arrayUrlYDeep.push(
        routerLoader.LoadRouteByPathChoosingBetweenAppOrWeb(
          vistaFront[j],
          deepLinkApp[j],
          idioma,
          isCaprabo,
          isApp,
        ),
      );
    }
    return arrayUrlYDeep;
  };

  static getUrlDeepLink = async (
    viewFrontMap: string[],
    deepLinkAppMap: string[],
    idioma: string,
    isApp: boolean,
    isCaprabo: boolean,
  ) => {
    let arrPathsUrlDeepLink: string[] = new Array<string>();
    await DeepLinkService.getUrlByDeepLink({
      locale: idioma,
      isWeb: !isApp,
      destino: deepLinkAppMap,
    })
      .then((response) => {
        const { data } = response;
        if (
          data === '' ||
          data.pojo === null ||
          data.pojo.url === null ||
          data.error ||
          data.pojo.error
        ) {
          arrPathsUrlDeepLink = AhorrosHelper.getWebViewFront(
            viewFrontMap,
            deepLinkAppMap,
            idioma,
            isApp,
            isCaprabo,
          );
        } else {
          arrPathsUrlDeepLink = data.pojo.url;
        }
      })
      .catch((e) => {
        console.log(e);
        arrPathsUrlDeepLink = AhorrosHelper.getWebViewFront(
          viewFrontMap,
          deepLinkAppMap,
          idioma,
          isApp,
          isCaprabo,
        );
      });
    return arrPathsUrlDeepLink;
  };
}
